import { Reveal, Overline } from "./Reveal";
import { FEATURES } from "./data";
import { Check } from "lucide-react";

export const Features = () => (
  <section id="features" data-testid="features-section" className="py-24 md:py-40 bg-surface/40 border-y border-line/40">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
        <Reveal>
          <Overline>Everything included</Overline>
          <h2 className="font-serif font-light tracking-tight leading-[0.95] text-textMain text-4xl md:text-5xl lg:text-6xl mt-6">
            Thoughtfully chosen,<br />down to the detail
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="font-sans text-textMuted max-w-sm leading-relaxed">
            The little extras guests don't expect but always appreciate — from premium coffee to breakfast provisions and complimentary toiletries.
          </p>
        </Reveal>
      </div>

      <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-12 border-t border-line/60">
        {FEATURES.map((f, i) => (
          <Reveal key={f} delay={Math.min(i * 0.04, 0.4)} y={20}>
            <li
              data-testid={`feature-item-${i}`}
              className="flex items-center gap-4 py-5 border-b border-line/60 group"
            >
              <Check className="w-4 h-4 text-primary shrink-0 transition-transform group-hover:scale-125" strokeWidth={2} />
              <span className="font-sans text-[15px] md:text-base text-textMain/85 group-hover:text-primary transition-colors">
                {f}
              </span>
            </li>
          </Reveal>
        ))}
      </ul>
    </div>
  </section>
);
